import map from 'lodash/map'
import { InvoiceStatusConstant } from '@ztechapps/totalmilk-payme.common'

export const invoiceStatuses = map(InvoiceStatusConstant, (e) => {
  return e.value
})
